import { IBudgetCost as BudgetCost, IBudgetCostReport } from '../../models/budgetCost';
import { MultiResponseType } from '../../models/multiResponseType';

export enum ActionType {
    FETCH_BUDGETCOSTS = 'FETCH_BUDGETCOSTS',
    FETCH_BUDGETCOSTS_SUCCESS = 'FETCH_BUDGETCOSTS_SUCCESS',
    FETCH_BUDGETCOSTS_FAIL = 'FETCH_BUDGETCOSTS_FAIL',
    FETCH_BUDGETCOSTSREPORT = 'FETCH_BUDGETCOSTSREPORT',
    FETCH_BUDGETCOSTSREPORT_SUCCESS = 'FETCH_BUDGETCOSTSREPORT_SUCCESS',
    FETCH_BUDGETCOSTSREPORT_FAIL = 'FETCH_BUDGETCOSTSREPORT_FAIL',
    ADD_BUDGETCOST = 'ADD_BUDGETCOST',
    ADD_BUDGETCOST_SUCCESS = 'ADD_BUDGETCOST_SUCCESS',
    ADD_BUDGETCOST_FAIL = 'ADD_BUDGETCOST_FAIL',
    EDIT_BUDGETCOST = 'EDIT_BUDGETCOST',
    EDIT_BUDGETCOST_SUCCESS = 'EDIT_BUDGETCOST_SUCCESS',
    EDIT_BUDGETCOST_FAIL = 'EDIT_BUDGETCOST_FAIL',
    DELETE_BUDGETCOST = 'DELETE_BUDGETCOST',
    DELETE_BUDGETCOST_SUCCESS = 'DELETE_BUDGETCOST_SUCCESS',
    DELETE_BUDGETCOST_FAIL = 'DELETE_BUDGETCOST_FAIL',
    SET_ADMIN_BUDGET_DESCRIPTION = 'SET_ADMIN_BUDGET_DESCRIPTION',
    SET_ADMIN_BUDGET_DESCRIPTION_SUCCESS = 'SET_ADMIN_BUDGET_DESCRIPTION_SUCCESS',
    SET_ADMIN_BUDGET_DESCRIPTION_FAIL = 'SET_ADMIN_BUDGET_DESCRIPTION_FAIL',
}

export interface IFetchBudgetCosts {
    type: ActionType.FETCH_BUDGETCOSTS;
}
export interface IFetchBudgetCostsSuccess {
    type: ActionType.FETCH_BUDGETCOSTS_SUCCESS;
    payload: MultiResponseType<BudgetCost>;
}
export interface IFetchBudgetCostsFail {
    type: ActionType.FETCH_BUDGETCOSTS_FAIL;
    payload: string | null;
}

export interface IFetchBudgetCostsReport {
    type: ActionType.FETCH_BUDGETCOSTSREPORT;
}
export interface IFetchBudgetCostsReportSuccess {
    type: ActionType.FETCH_BUDGETCOSTSREPORT_SUCCESS;
    payload: MultiResponseType<IBudgetCostReport>;
}
export interface IFetchBudgetCostsReportFail {
    type: ActionType.FETCH_BUDGETCOSTSREPORT_FAIL;
    payload: string | null;
}

export interface IAddBudgetCost {
    type: ActionType.ADD_BUDGETCOST;
}
export interface IAddBudgetCostSuccess {
    type: ActionType.ADD_BUDGETCOST_SUCCESS;
    payload: BudgetCost;
}
export interface IAddBudgetCostFail {
    type: ActionType.ADD_BUDGETCOST_FAIL;
    payload: string | null;
}

export interface IEditBudgetCost {
    type: ActionType.EDIT_BUDGETCOST;
}
export interface IEditBudgetCostSuccess {
    type: ActionType.EDIT_BUDGETCOST_SUCCESS;
    payload: BudgetCost;
}
export interface IEditBudgetCostFail {
    type: ActionType.EDIT_BUDGETCOST_FAIL;
    payload: string | null;
}
export interface IDeleteBudgetCost {
    type: ActionType.DELETE_BUDGETCOST;
}
export interface IDeleteBudgetCostSuccess {
    type: ActionType.DELETE_BUDGETCOST_SUCCESS;
    payload: number;
}
export interface IDeleteBudgetCostFail {
    type: ActionType.DELETE_BUDGETCOST_FAIL;
    payload: string | null;
}

export interface ISetAdminBudgetDescription {
    type: ActionType.SET_ADMIN_BUDGET_DESCRIPTION;
}
export interface ISetAdminBudgetDescriptionSuccess {
    type: ActionType.SET_ADMIN_BUDGET_DESCRIPTION_SUCCESS;
    payload: string | null;
}
export interface ISetAdminBudgetDescriptionFail {
    type: ActionType.SET_ADMIN_BUDGET_DESCRIPTION_FAIL;
    payload: string | null;
}

export type Action =
    | IFetchBudgetCosts
    | IFetchBudgetCostsSuccess
    | IFetchBudgetCostsFail
    | IFetchBudgetCostsReport
    | IFetchBudgetCostsReportSuccess
    | IFetchBudgetCostsReportFail
    | IAddBudgetCost
    | IAddBudgetCostSuccess
    | IAddBudgetCostFail
    | IEditBudgetCost
    | IEditBudgetCostSuccess
    | IEditBudgetCostFail
    | IDeleteBudgetCost
    | IDeleteBudgetCostSuccess
    | IDeleteBudgetCostFail
    | ISetAdminBudgetDescription
    | ISetAdminBudgetDescriptionSuccess
    | ISetAdminBudgetDescriptionFail
